/*=========================================================================================
  File Name: moduleNotificationsState.js
  Description: Notifications Module State
==========================================================================================*/

export default {
	total: 0,
	limitPerPage: 20,
	currentPage: 1,
	missions: [],
	audios: [],
	playedAudios: [],
	indexUpdate: 0
};
